
[
  {
    "id": "TIJD-TAB-L3-001",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Op de menukaart staat: Pannenkoek € 5,00. Toeslag spek: + € 1,50. Toeslag kaas: + € 1,00. Je bestelt een pannenkoek met spek én kaas. Wat betaal je?",
    "options": ["€ 7,50", "€ 6,50", "€ 6,00", "€ 8,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-MENU",
    "explanation": "Tel alles op: € 5,00 (pannenkoek) + € 1,50 (spek) + € 1,00 (kaas) = € 7,50.",
    "distractorExplanations": { "1": "Je bent de kaas vergeten! Tel ook de € 1,00 voor kaas erbij.", "2": "Je bent het spek vergeten! Tel ook de € 1,50 voor spek erbij.", "3": "Je hebt iets dubbel geteld. Check: 5 + 1,50 + 1 = 7,50." },
    "visualAid": { "type": "ratio", "data": { "headers": ["Item", "Prijs"], "rows": [["Pannenkoek", "€ 5,00"], ["+ Spek", "€ 1,50"], ["+ Kaas", "€ 1,00"], ["Totaal", "€ 7,50"]], "highlightRow": 3 }, "showWhen": "wrong" }
  },
  {
    "id": "TIJD-TAB-L3-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Afstandstabel: Van A naar B is 10 km. Van B naar C is 5 km. Van A naar C (via B) is ... km?",
    "options": ["15 km", "5 km", "50 km", "20 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-AFSTAND",
    "explanation": "Je reist eerst 10 km, dan nog 5 km. Tel op: 10 + 5 = 15 km.",
    "distractorExplanations": { "1": "Je hebt afgetrokken (10 - 5). Maar je reist verder, dus je moet optellen!", "2": "Je hebt vermenigvuldigd (10 × 5). Maar bij afstanden tel je op!", "3": "Rekenfoutje. Check: 10 + 5 = 15." },
    "visualAid": { "type": "ratio", "data": { "headers": ["Van", "Naar", "Afstand"], "rows": [["A", "B", "10 km"], ["B", "C", "5 km"], ["A", "C (via B)", "15 km"]], "highlightRow": 2 }, "showWhen": "wrong" }
  },
  {
    "id": "TIJD-KLOK-L3-001",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Een atleet loopt 400 meter in 58,75 seconden. Hoeveel is dat in minuten en seconden?",
    "options": ["0 minuten en 58,75 seconden", "58 minuten en 75 seconden", "5 minuten en 8,75 seconden", "0 minuten en 59 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TIJD-KLOK-ATLEET",
    "explanation": "58,75 seconden is minder dan 60 seconden, dus het is 0 minuten en 58,75 seconden.",
    "distractorExplanations": { "1": "Dit zou betekenen dat 58 minuten en 75 seconden, maar dat kan niet!", "2": "Rekenfout. 58,75 seconden is nog geen minuut.", "3": "59 seconden is afgerond, maar de vraag vraagt om het exacte getal." }
  },
  {
    "id": "TIJD-KLOK-L3-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "De klok toont 23:59:45. Over hoeveel seconden begint de nieuwe dag?",
    "options": ["15 seconden", "45 seconden", "60 seconden", "30 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-KLOK-MIDDERNACHT",
    "explanation": "Van 23:59:45 naar 00:00:00 (middernacht) is 15 seconden. 60 - 45 = 15.",
    "distractorExplanations": { "1": "45 seconden is hoeveel er al voorbij is, niet hoeveel er nog komt!", "2": "60 seconden is een hele minuut, maar we zitten al bij 45 seconden.", "3": "30 seconden zou 23:59:30 zijn." }
  },
  {
    "id": "TIJD-KLOK-L3-003",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Een liedje duurt 3 minuten en 15 seconden. Hoeveel seconden is dat in totaal?",
    "options": ["195 seconden", "315 seconden", "180 seconden", "215 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TIJD-KLOK-LIEDJE",
    "explanation": "3 minuten = 3 × 60 = 180 seconden. Plus 15 seconden = 180 + 15 = 195 seconden.",
    "distractorExplanations": { "1": "Je hebt de minuten en seconden door elkaar gehaald. 3 minuten is 180 seconden, niet 315.", "2": "180 seconden is alleen de 3 minuten. Je moet nog de 15 seconden erbij tellen!", "3": "Rekenfout. Check: 3 × 60 = 180, dan 180 + 15 = 195." },
    "visualAid": { "type": "rule", "data": { "title": "Minuten naar Seconden", "content": "1 minuut = 60 seconden. Dus 3 minuten = 3 × 60 = 180 seconden. Tel de extra seconden erbij op!", "icon": "lightbulb" }, "showWhen": "wrong" }
  },
  {
    "id": "TIJD-KLOK-INT-L3-001",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Hoe laat is het? Let goed op alle wijzers!",
    "options": ["11:58:45", "11:58:09", "12:58:45", "10:58:45"],
    "correctAnswer": 0,
    "questionType": "klok_aflezen",
    "skill": "klokkijken",
    "subSkill": "klokkijken_seconden",
    "familyId": "TIJD-KLOK-INT-COMPLEX",
    "context": "Het is 's ochtends, bijna tijd voor de pauze.",
    "explanation": "Het is 's ochtends, bijna pauze. De kleine wijzer staat bijna op 12 (dus 11 uur). De minutenwijzer staat op 58. De secondewijzer op 45 (bij de 9).",
    "distractorExplanations": { "1": "Je hebt de secondewijzer als cijfer gelezen (9) in plaats van seconden (45).", "2": "Het is nog geen 12 uur (of 13 uur).", "3": "Je hebt een uur te vroeg gekozen." }
  },
  {
    "id": "GELD-SAMEN-L3-001",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Maak precies €18,70",
    "options": ["1000", "500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 1870,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-ADVANCED-1",
    "explanation": "Je moet €18,70 maken. Bijvoorbeeld: €10 + €5 + €2 + €1 + 50 cent + 20 cent = €18,70.",
    "distractorExplanations": { "1": "Je hebt te weinig gekozen. €18,70 is 1870 cent.", "2": "Je hebt te veel gekozen. Tel je munten en biljetten nog eens na.", "3": "Je bent 50 cent vergeten.", "4": "Je bent €1 vergeten." }
  },
  {
    "id": "GELD-SAMEN-L3-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Maak precies €23,45",
    "options": ["2000", "1000", "500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 2345,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-ADVANCED-2",
    "explanation": "Je moet €23,45 maken. Bijvoorbeeld: €20 + €2 + €1 + 20 cent + 20 cent + 5 cent = €23,45.",
    "distractorExplanations": { "1": "Je hebt te weinig gekozen. €23,45 is 2345 cent.", "2": "Je hebt te veel gekozen. Tel je munten en biljetten nog eens na.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-SAMEN-L3-003",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Maak precies €31,25",
    "options": ["2000", "1000", "500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 3125,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-ADVANCED-3",
    "explanation": "Je moet €31,25 maken. Bijvoorbeeld: €20 + €10 + €1 + 20 cent + 5 cent = €31,25.",
    "distractorExplanations": { "1": "Je hebt te weinig gekozen. €31,25 is 3125 cent.", "2": "Je hebt te veel gekozen. Tel je munten en biljetten nog eens na.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-WISSEL-L3-001",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Je koopt iets van € 27,85 en betaalt met € 50,00. Maak het wisselgeld",
    "options": ["2000", "1000", "500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 2215,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-COMPLEX-1",
    "explanation": "Je betaalt €50 voor iets van €27,85. Wisselgeld: €50 - €27,85 = €22,15.",
    "distractorExplanations": { "1": "Je hebt te weinig wisselgeld gemaakt. €50 - €27,85 = €22,15.", "2": "Je hebt te veel wisselgeld gemaakt. €50 - €27,85 = €22,15.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-WISSEL-L3-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Een jas kost € 43,95. Je betaalt met 2 briefjes van € 20 en 1 van € 10. Maak het wisselgeld",
    "options": ["500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 605,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-COMPLEX-2",
    "explanation": "Je betaalt €50 (2×€20 + 1×€10) voor iets van €43,95. Wisselgeld: €50 - €43,95 = €6,05.",
    "distractorExplanations": { "1": "Je hebt te weinig wisselgeld gemaakt. €50 - €43,95 = €6,05.", "2": "Je hebt te veel wisselgeld gemaakt. €50 - €43,95 = €6,05.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-WISSEL-L3-003",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Je betaalt € 38,70 voor schoenen met een briefje van € 50,00. Maak het wisselgeld",
    "options": ["1000", "500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 1130,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-COMPLEX-3",
    "explanation": "Je betaalt €50 voor iets van €38,70. Wisselgeld: €50 - €38,70 = €11,30.",
    "distractorExplanations": { "1": "Je hebt te weinig wisselgeld gemaakt. €50 - €38,70 = €11,30.", "2": "Je hebt te veel wisselgeld gemaakt. €50 - €38,70 = €11,30.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-PRIJS-L2-001",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Pak A: 6 eieren voor € 2,40. Pak B: 10 eieren voor € 3,50. Welk pak is voordeliger per ei?",
    "options": ["Pak B", "Pak A", "Even duur", "Kan niet berekenen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "GELD-PRIJS-MEDIUM-1",
    "explanation": "Pak A: €2,40 ÷ 6 = €0,40 per ei. Pak B: €3,50 ÷ 10 = €0,35 per ei. Pak B is voordeliger!",
    "distractorExplanations": { "1": "Pak A kost €0,40 per ei. Pak B kost €0,35 per ei. Pak B is goedkoper!", "2": "De prijzen per ei zijn niet gelijk: €0,40 ≠ €0,35.", "3": "Je kunt het wel berekenen! Deel de prijs door het aantal eieren." }
  },
  {
    "id": "GELD-PRIJS-L2-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Fles A: 1 liter sap voor € 2,00. Fles B: 1,5 liter sap voor € 2,70. Welke is voordeliger per liter?",
    "options": ["Fles B", "Fles A", "Even duur", "Fles A en B"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "GELD-PRIJS-MEDIUM-2",
    "explanation": "Fles A: €2,00 ÷ 1 = €2,00 per liter. Fles B: €2,70 ÷ 1,5 = €1,80 per liter. Fles B is voordeliger!",
    "distractorExplanations": { "1": "Fles A kost €2,00 per liter. Fles B kost €1,80 per liter. Fles B is goedkoper!", "2": "De prijzen per liter zijn niet gelijk: €2,00 ≠ €1,80.", "3": "Je moet kiezen: Fles B is voordeliger per liter." }
  },
  {
    "id": "GELD-BOOD-L3-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Boodschappenlijst: vlees € 8,95, groente € 3,45, fruit € 4,60, drinken € 5,20. Totaal?",
    "options": ["€ 22,20", "€ 21,20", "€ 23,20", "€ 22,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "GELD-BOOD-COMPLEX-2",
    "explanation": "Vlees €8,95 + groente €3,45 + fruit €4,60 + drinken €5,20 = €22,20.",
    "distractorExplanations": { "1": "Je bent €1 vergeten. Check: €8,95 + €3,45 + €4,60 + €5,20 = €22,20.", "2": "Je hebt €1 te veel. Check: €8,95 + €3,45 + €4,60 + €5,20 = €22,20.", "3": "Je hebt 20 cent te weinig. Check: €8,95 + €3,45 + €4,60 + €5,20 = €22,20." }
  },
  {
    "id": "GELD-SPAAR-L3-002",
    "module": "TijdGeld",
    "difficulty": 105,
    "question": "Je budget is € 50,00. Je koopt een boek voor € 12,50 en een game voor € 28,75. Hoeveel blijft over?",
    "options": ["€ 8,75", "€ 9,75", "€ 7,75", "€ 10,75"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "GELD-SPAAR-COMPLEX-2",
    "explanation": "Budget €50. Boek €12,50 + game €28,75 = €41,25. Over: €50 - €41,25 = €8,75.",
    "distractorExplanations": { "1": "Je hebt €1 te veel berekend. €50 - €41,25 = €8,75.", "2": "Je hebt €1 te weinig berekend. €50 - €41,25 = €8,75.", "3": "Je hebt €2 te veel berekend. €50 - €41,25 = €8,75." }
  }
]
